var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.498,
    height: 14.085,
    viewBox: "0 0 6.498 14.085",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e74e0f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M843.189,223.071h5.021s1.367,3.785.409,5.8c-1.217,2.555-2.619,1.006-2.619,3.545v3.641c0,.766,2.315.335,2.315,1.1h-5.2c0-.766,2.315-.335,2.315-1.1v-3.641c0-2.539-1.4-.99-2.619-3.545-.958-2.012.382-5.8.382-5.8",
    transform: "translate(-842.462 -223.071)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerreIcon);
export default __webpack_public_path__ + "static/media/verreIcon.9e67e219.svg";
export { ForwardRef as ReactComponent };